/**
 * undefined 转 空字符串
 */
export function noneToEmptyStr(value) {
  if (!value || typeof value === 'undefined' || value === 'undefined') {
    return '';
  }
  return value;
}

/**
 * 去除字符串两端空格
 * @param value string
 */
export function trim(value) {
  return value.replace(/(^\s*)|(\s*$)/g, '');
}

/**
 * title换行
 */
export function titleMultiLine(str, cosNum = 30) {
  if (!str) {
    return '';
  }
  const { userAgent } = window.navigator;
  if (/webkit/i.test(userAgent)) {
    return str;
  }
  const ret = new RegExp(`(.{${cosNum}})`, 'g');
  return str.replace(ret, '$1' + '\n');
}

export function getUuid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  return (`${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`);
}

/**
 * 是否为非空字符串
 */
export function nonEmptyString(value) {
  return (
    Object.prototype.toString.call(value) === '[object String]' && value !== ''
  );
}
